<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 
    import ToolTip from '../components/ToolTip.svelte'; 

    let isLoading = false;
    let sku = "";
    let date_start = '';
    let date_end = '';
    


    onMount(async() => {

        console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
       
    })


    const handleProducts = async() => {

        isLoading = true;
        let postData = {};

        postData.action = 'crm_integration_products';
        postData.token = $UserStore.data
        postData.date_end = date_end
        postData.date_start = date_start;
        postData.sku = sku

        let response = await fetchData(postData);
        if (response.data) {

        }
        isLoading = false;

    }

    const handleStock = async() => {

        isLoading = true;
        let postData = {};

        postData.action = 'crm_integration_stocks';
        postData.token = $UserStore.data
        postData.date_end = date_end
        postData.date_start = date_start;
        postData.sku = sku

        let response = await fetchData(postData);
        if (response.data) {

        }
        isLoading = false;

    }



    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">
            <h1 class="text-[20px] font-bold">{$_('integration.title')}</h1>        
            <div class="shipment-flex mb-[50px]">

                <div class="input_box items-end">
                    <div class="py-3 font-bold">{$_('integration.products')}</div>
                    <div class="input_con">
                        <label>{$_('integration.sku')}</label>
                        <input type="text" bind:value={sku}>
                    </div>
                    <div class="input_con">
                        <label>{$_('integration.date_start')}</label>
                        <input type="date" bind:value={date_start}>
                    </div>      
                    <div class="input_con">
                        <label> {$_('integration.date_end')}</label>
                        <input type="date" bind:value={date_end}>
                    </div>
                    <div>
                        <div class="create_button" on:click={ handleProducts }>{$_('integration.run')}</div>
                    </div>
                </div>

                <div class="input_box items-end">
                    <div class="py-3 font-bold">{$_('integration.stock')}</div>
                    <div class="input_con">
                        <label>{$_('integration.sku')}</label>
                        <input type="text" bind:value={sku}>
                    </div>
                    <div class="input_con">
                        <label>{$_('integration.date_start')}</label>
                        <input type="date" bind:value={date_start}>
                    </div>      
                    <div class="input_con">
                        <label> {$_('integration.date_end')}</label>
                        <input type="date" bind:value={date_end}>
                    </div>
                    <div>
                        <div class="create_button" on:click={ handleStock }>{$_('integration.run')}</div>
                    </div>
                </div>


                <div>{$_('integration.log')}</div>
                

            </div> 
  

        </div>
        
    </div>
</div>

